import { useState, useMemo } from "react"
import { Button, Typography, Box } from "@mui/material"
import useLang from "../../../hooks/useLang"

// Composant réutilisable pour afficher une liste tronquée / développée
interface ExpandableListProps {
  items: string[]
  maxItems?: number
}

const ExpandableList = ({ items, maxItems = 2 }: ExpandableListProps) => {
  const [expanded, setExpanded] = useState(false)
  const { getText } = useLang()

  // Liste à afficher selon l’état
  const displayed = useMemo(
    () => (expanded ? items : items.slice(0, maxItems)),
    [expanded, items, maxItems],
  )

  // Texte du bouton
  const toggleLabel = expanded ? getText("Voir moins") : getText("Voir plus")

  return (
    <Box>
      <Typography variant="body2" component="span">
        {displayed.join("; ")}
        {items.length > maxItems && "…"}
      </Typography>
      {items.length > maxItems && (
        <Button
          size="small"
          variant="text"
          onClick={() => setExpanded(!expanded)}
          sx={{ textTransform: "none", ml: 1, color: "palegoldenrod" }}
        >
          {toggleLabel}
        </Button>
      )}
    </Box>
  )
}

export default ExpandableList
